// This file contains constants used throughout the application.
// It is important to keep sensitive information like client IDs and secrets out of the codebase.

const AZURE_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";
const AZURE_APP_AUTHORITY = process.env.REACT_APP_AUTHORITY || "";
const APP_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || "";
const BASE_URL = process.env.REACT_APP_BASE_URL || "";
const APP_POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "";
const REQUIRED_GROUP_ID = process.env.REACT_APP_REQUIRED_GROUP_ID || "";
const CONTACT_URL = process.env.REACT_APP_CONTACT_URL || "";
const APPINSIGHTS_KEY = process.env.REACT_APP_APPINSIGHTS_KEY || "";


export {
    AZURE_APP_CLIENT_ID,
    AZURE_APP_AUTHORITY,
    APP_REDIRECT_URI,
    APP_POST_LOGOUT_REDIRECT_URI,
    BASE_URL,
    REQUIRED_GROUP_ID,
    CONTACT_URL,
    APPINSIGHTS_KEY
}